<app-menu [isSecured]="isLoggedIn"></app-menu>
<ng-content></ng-content>
